import {
  PEGMAN_NEIGHBOR_GAP_PX, PEGMAN_SIZE_PX,
} from '~/_shared/components/google-map/googleMap.constants';
import { ZOOM_BUTTON_SIZE } from '~/map/mapToolControls/menuItems/zoomControls/zoomControls.component';

export const GOOGLE_LOGO_SAFE_BOTTOM_OFFSET_PX = 30;
export const GOOGLE_LOGO_SAFE_LEFT_OFFSET_PX = 66; // observed width of the Google Maps logo
export const MAPS_ATTRIBUTION_BAR_BOTTOM_OFFSET_PX = 20;

const SAFETY_GAP = 8;

export const RIGHT_SIDE_RIGHT_OFFSET_PX = 5;

// Bottom-right cluster: zoom controls (right column) with the street view pegman a column to their left.
export const ZOOM_CONTROLS_SAFE_BOTTOM_OFFSET_PX = MAPS_ATTRIBUTION_BAR_BOTTOM_OFFSET_PX + 2 * ZOOM_BUTTON_SIZE + SAFETY_GAP;
export const BOTTOM_RIGHT_CLUSTER_SAFE_RIGHT_OFFSET_PX = ZOOM_BUTTON_SIZE + PEGMAN_SIZE_PX + PEGMAN_NEIGHBOR_GAP_PX + RIGHT_SIDE_RIGHT_OFFSET_PX;
